import { createPublisherBillingInfo } from "actions/publisher";
import React, { useEffect, useRef, useState } from "react";

import {
  Card,
  Col,
  Row,
  Container,
  CardBody,
  Button,
  Input,
  Label,
  FormFeedback,
  FormGroup,
  Badge,
  UncontrolledTooltip,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { billingInfoByPublisherId, bankDetailsHistoryList } from "actions/publisher";
import ReactBsTable from "components/Tables/ReactBsTable";
import BankDetailModal from "components/Modal/BankDetailModal";

// Countries list for display
const countriesMap = {
  1: "United Arab Emirates",
  2: "United States",
  3: "Hong Kong",
  4: "India",
  5: "Germany",
  6: "United Kingdom",
  7: "Singapore",
  8: "Australia",
  9: "Canada",
  10: "Japan",
  11: "China",
  12: "Brazil",
  13: "South Africa",
  14: "Nigeria",
  15: "Kenya",
  16: "Egypt",
  17: "Malaysia",
  18: "Indonesia",
  19: "Philippines",
  20: "Thailand",
  21: "Vietnam",
  22: "Taiwan",
  23: "South Korea",
  24: "New Zealand",
  25: "France",
  26: "Italy",
  27: "Spain",
  28: "Mexico",
  29: "Argentina",
  30: "Chile",
  31: "Colombia",
  32: "Peru",
  33: "Venezuela",
  34: "Pakistan",
  35: "Bangladesh",
  36: "Sri Lanka",
  37: "Nepal",
  38: "Afghanistan"
};

const Publisher_Billing = () => {
  const [formState, setformState] = useState({
    legal_entity_name: { value: "", error: "" },
    recipient_name: { value: "", error: "" },
    bank_name: { value: "", error: "" },
    country_id: { value: "", error: "" },
    country_name: { value: "", error: "" },
    billing_address: { value: "", error: "" },
    trn_vat_id: { value: "", error: "" },
    payment_currency: { value: "", error: "" },
    recipient_address: { value: "", error: "" },
    bank_account: { value: "", error: "" },
    account_number: { value: "", error: "" },
    bank_address: { value: "", error: "" },
    iban: { value: "", error: "" },
    swift_bic: { value: "", error: "" },
    swift_code: { value: "", error: "" },
    routing_number: { value: "", error: "" },
    ifsc_code: { value: "", error: "" },
    invoice_email: { value: "", error: "" },
    tax_residency: { value: "", error: "" },
    payment_terms: { value: "", error: "" },
    minimum_payout: { value: "", error: "" },
    approval_status: { value: "", error: "" },
    created_at: { value: "", error: "" },
    updated_at: { value: "", error: "" },
    approved_by: { value: "", error: "" },
    approved_at: { value: "", error: "" },
  });

  const [showLoader, setShowLoader] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isBankModalOpen, setIsBankModalOpen] = useState(false);
  const [bankHistory, setBankHistory] = useState([]);
  const [historyLoader, setHistoryLoader] = useState(false);

  const [billingInfoForm, setbillingInfoForm] = useState({
    id: "",
    legal_entity_name: { value: "", error: "" },
    recipient_name: { value: "", error: "" },
    bank_name: { value: "", error: "" },
    country_id: { value: "", error: "" },
    country_name: { value: "", error: "" },
    billing_address: { value: "", error: "" },
    trn_vat_id: { value: "", error: "" },
    payment_currency: { value: "", error: "" },
    recipient_address: { value: "", error: "" },
    bank_account: { value: "", error: "" },
    account_number: { value: "", error: "" },
    bank_address: { value: "", error: "" },
    iban: { value: "", error: "" },
    swift_bic: { value: "", error: "" },
    swift_code: { value: "", error: "" },
    routing_number: { value: "", error: "" },
    ifsc_code: { value: "", error: "" },
    invoice_email: { value: "", error: "" },
    tax_residency: { value: "", error: "" },
    payment_terms: { value: "", error: "" },
    minimum_payout: { value: "", error: "" },
    approval_status: { value: "", error: "" },
    created_at: { value: "", error: "" },
    updated_at: { value: "", error: "" },
    approved_by: { value: "", error: "" },
    approved_at: { value: "", error: "" },
  });

  const notificationAlertRef = useRef(null);
  const publisherID = JSON.parse(localStorage.getItem("p")).publisherID;

  //==> handleInputChange function
  const handleInputChange = (key, value) => {
    setformState((prev) => ({
      ...prev,
      [key]: { value: value, error: "" },
    }));
  };

  //==> notify function
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  //==> getBillingInfo function
  const getBillingInfo = async () => {
    setShowLoader(true);
    try {
      const res = await billingInfoByPublisherId(publisherID);
      if (res.code === 200) {
        let data = res?.data;

        // Get country name from countryId
        const countryName = data?.countryId ? countriesMap[data.countryId] || "" : "";

        setbillingInfoForm({
          id: data?.id || "",
          legal_entity_name: { value: data?.legalName || "", error: "" },
          recipient_name: { value: data?.recipientName || data?.accountName || "", error: "" },
          bank_name: { value: data?.bankName || "", error: "" },
          country_id: { value: data?.countryId || "", error: "" },
          country_name: { value: countryName, error: "" },
          billing_address: { value: data?.billingAddress || "", error: "" },
          trn_vat_id: { value: data?.vatNumber || "", error: "" },
          payment_currency: { value: data?.paymentCurrency || "", error: "" },
          recipient_address: { value: data?.recipientAddress || "", error: "" },
          bank_account: { value: data?.bankAccount || data?.accountNumber || "", error: "" },
          account_number: { value: data?.accountNumber || "", error: "" },
          bank_address: { value: data?.bankAddress || "", error: "" },
          iban: { value: data?.iban || "", error: "" },
          swift_bic: { value: data?.swiftBic || data?.swiftCode || "", error: "" },
          swift_code: { value: data?.swiftCode || "", error: "" },
          routing_number: { value: data?.routingNumber || "", error: "" },
          ifsc_code: { value: data?.ifscCode || "", error: "" },
          invoice_email: { value: data?.invoiceEmail || "", error: "" },
          tax_residency: { value: data?.taxResidency || "", error: "" },
          payment_terms: { value: data?.paymentTerms || "", error: "" },
          minimum_payout: { value: data?.minimumPayout || "", error: "" },
          approval_status: { value: data?.approvalStatus || "PENDING", error: "" },
          created_at: { value: data?.createdAt || "", error: "" },
          updated_at: { value: data?.updatedAt || "", error: "" },
          approved_by: { value: data?.approvedBy || "", error: "" },
          approved_at: { value: data?.approvedAt || "", error: "" },
        });

        // Populate form state for editing
        setformState({
          legal_entity_name: { value: data?.legalName || "", error: "" },
          recipient_name: { value: data?.recipientName || data?.accountName || "", error: "" },
          bank_name: { value: data?.bankName || "", error: "" },
          country_id: { value: data?.countryId || "", error: "" },
          country_name: { value: countryName, error: "" },
          billing_address: { value: data?.billingAddress || "", error: "" },
          trn_vat_id: { value: data?.vatNumber || "", error: "" },
          payment_currency: { value: data?.paymentCurrency || "", error: "" },
          recipient_address: { value: data?.recipientAddress || "", error: "" },
          bank_account: { value: data?.bankAccount || data?.accountNumber || "", error: "" },
          account_number: { value: data?.accountNumber || "", error: "" },
          bank_address: { value: data?.bankAddress || "", error: "" },
          iban: { value: data?.iban || "", error: "" },
          swift_bic: { value: data?.swiftBic || data?.swiftCode || "", error: "" },
          swift_code: { value: data?.swiftCode || "", error: "" },
          routing_number: { value: data?.routingNumber || "", error: "" },
          ifsc_code: { value: data?.ifscCode || "", error: "" },
          invoice_email: { value: data?.invoiceEmail || "", error: "" },
          tax_residency: { value: data?.taxResidency || "", error: "" },
          payment_terms: { value: data?.paymentTerms || "", error: "" },
          minimum_payout: { value: data?.minimumPayout || "", error: "" },
          approval_status: { value: data?.approvalStatus || "PENDING", error: "" },
          created_at: { value: data?.createdAt || "", error: "" },
          updated_at: { value: data?.updatedAt || "", error: "" },
          approved_by: { value: data?.approvedBy || "", error: "" },
          approved_at: { value: data?.approvedAt || "", error: "" },
        });
        setShowLoader(false);
      } else {
        setShowLoader(false);
      }
    } catch (error) {
      setShowLoader(false);
      console.error("Error fetching billing info:", error);
    }
  };

  //==> getBankHistory function
  const getBankHistory = async () => {
    setHistoryLoader(true);
    try {
      const res = await bankDetailsHistoryList(publisherID);
      console.log("Bank History Response:", res);
      if (res?.code === 200) {
        // The response data is an array of objects
        const dataArray = res?.data?.PublisherBillingInfo || [];
        // Map the response data to match the table format
        const historyData = dataArray.map(item => ({
          id: item.id,
          legal_entity_name: item.legalName || "-",
          rejection_reason: item.rejectionReason || "-",
          recipient_name: item.accountName || item.recipientName || "-",
          country: item.countryName || "-",
          billing_address: item.billingAddress || "-",
          trn_vat_id: item.vatNumber || "-",
          payment_currency: item.paymentCurrency || "-",
          bank_name: item.bankName || "-",
          bank_account: item.accountNumber || item.bankAccount || "-",
          bank_address: item.bankAddress || "-",
          iban: item.iban || "-",
          swift_bic: item.swiftCode || item.swiftBic || "-",
          routing_number: item.routingNumber || "-",
          ifsc_code: item.ifscCode || "-",
          invoice_contact_email: item.invoiceEmail || "-",
          tax_residency: item.taxResidency || "-",
          status: item.status || "INACTIVE",
          approval_status: item.approvalStatus || "PENDING",
          updated_at: item.updatedAt || "-",
          approved_by: item.approvedBy || "-",
          approved_at: item.approvedAt || "-",
          created_at: item.createdAt || "-",
          payment_terms: item.paymentTerms || "-",
          minimum_payout: item.minimumPayout || 0,
        }));
        setBankHistory(historyData);
      } else {
        setBankHistory([]);
      }
    } catch (error) {
      console.error("Error fetching bank history:", error);
      setBankHistory([]);
    } finally {
      setHistoryLoader(false);
    }
  };

  //==> handleBankSubmit function
  const handleBankSubmit = async (payload) => {

    try {
      setShowLoader(true);

      // Prepare the payload matching the Go struct
      const apiPayload = {
        publisherID: publisherID,
        legalName: payload.billingInfo.legalEntityName || payload.billingInfo.legal_entity_name,
        billingAddress: payload.billingInfo.billingAddress || payload.billingInfo.billing_address,
        country: parseInt(payload.billingInfo.country) || 0,
        vatNumber: payload.billingInfo.trnVatId || payload.billingInfo.trn_vat_id || "",
        paymentTerms: payload.billingInfo.paymentTerms || payload.billingInfo.payment_terms || "Net 30",
        minimumPayout: parseFloat(payload.billingInfo.minimumPayout) || 500,
        bankName: payload.billingInfo.bankName || payload.billingInfo.bank_name,
        accountNumber: payload.billingInfo.bankAccount || payload.billingInfo.bank_account,
        iban: payload.billingInfo.iban || "",
        swiftCode: payload.billingInfo.swiftBic || payload.billingInfo.swift_bic,
        ifscCode: payload.billingInfo.ifscCode || payload.billingInfo.ifsc_code || "",
        invoiceEmail: payload.billingInfo.contactEmail || payload.billingInfo.contact_email || payload.billingInfo.invoice_email,
        recipientName: payload.billingInfo.recipientName || payload.billingInfo.recipient_name || payload.billingInfo.legalEntityName,
        recipientAddress: payload.billingInfo.recipientAddress || payload.billingInfo.recipient_address,
        taxResidency: payload.billingInfo.taxResidency || payload.billingInfo.tax_residency || "",
        paymentCurrency: payload.billingInfo.paymentCurrency || payload.billingInfo.payment_currency || "USD",
        routingNumber: payload.billingInfo.routingNumber || payload.billingInfo.routing_number || "",
      };

      const res = await createPublisherBillingInfo(apiPayload);

      if (res.code === 200) {
        notify("success", "Bank details saved successfully! Awaiting admin approval.");
        setShowLoader(false);
        await Promise.all([getBillingInfo(), getBankHistory()]);
        return { code: 200 };
      } else {
        setShowLoader(false);
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to save bank details";
        notify("danger", message);
        return { code: res.code, message: message };
      }
    } catch (error) {
      setShowLoader(false);
      console.error("Error saving bank details:", error);
      notify("danger", "Something went wrong while saving bank details");
      return { code: 500, message: "Something went wrong" };
    }
  };

  useEffect(() => {
    getBillingInfo();
    getBankHistory();
  }, []);

  //==> hasBillingInfo function
  const hasBillingInfo = billingInfoForm.id !== "" && billingInfoForm.id !== null;

  //==> getStatusBadge function
  const getStatusBadge = (status) => {
    const statusMap = {
      APPROVED: { color: "success", label: "Approved" },
      PENDING: { color: "warning", label: "Pending" },
      REJECTED: { color: "danger", label: "Rejected" },
      INACTIVE: { color: "secondary", label: "Inactive" },
      ACTIVE: { color: "primary", label: "Active" },
    };
    const s = statusMap[status] || statusMap.PENDING;
    return <Badge color={s.color}>{s.label}</Badge>;
  };

  //==> Field Component
  const Field = ({ label, value }) => (
    <div className="mb-3">
      <Label className="text-muted small mb-1" style={{ fontSize: "12px", fontWeight: "600" }}>
        {label}
      </Label>
      <div className="font-weight" style={{ fontSize: "14px", color: "#2c3e50" }}>
        {value || "-"}
      </div>
    </div>
  );

  //==> Bank History Columns
  const bankHistoryColumns = [

    {
      dataField: "legal_entity_name",
      text: "Legal Entity Name",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },

    {
      dataField: "country",
      text: "Country",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "billing_address",
      text: "Billing Address",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "trn_vat_id",
      text: "TRN/VAT ID",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "payment_currency",
      text: "Currency",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "payment_terms",
      text: "Payment Terms",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "minimum_payout",
      text: "Min Payout",
      formatter: (cell) => cell ? `$${cell}` : "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "bank_name",
      text: "Bank Name",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "bank_account",
      text: "Account Number",
      formatter: (cell) => {
        if (!cell) return "-";
        if (cell.length > 4) {
          return "XXXX" + cell.slice(-4);
        }
        return cell;
      },
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "iban",
      text: "IBAN",
      formatter: (cell) => {
        if (!cell) return "-";
        if (cell.length > 8) {
          return cell.slice(0, 4) + "XXXX" + cell.slice(-4);
        }
        return cell;
      },
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "swift_bic",
      text: "SWIFT/BIC",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "ifsc_code",
      text: "IFSC Code",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
        {
      dataField: "tax_residency",
      text: "Tax Residency",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
{
  dataField: "approval_status",
  text: "Approval Status",
  formatter: (cell, row) => {
    const hasRejectionReason = row.rejection_reason && row.rejection_reason !== "-";
    const badge = getStatusBadge(cell);
    
    return (
      <div 
        title={hasRejectionReason ? `Rejection Reason: ${row.rejection_reason}` : ""}
        style={{ display: 'inline-block' }}
      >
        {badge}
      </div>
    );
  },
  headerStyle: { fontWeight: "bold" }
},
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => getStatusBadge(cell === "ACTIVE" ? "ACTIVE" : "INACTIVE"),
      headerStyle: { fontWeight: "bold" }
    },

    {
      dataField: "created_at",
      text: "Created At",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    },
    {
      dataField: "updated_at",
      text: "Updated At",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" }
    }
  ];

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <div className="action-form-container">
        <Container fluid className="mt--6">
          <Card className="advertiser-card">
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h4 className="advertiser-title mb-0">
                    Publisher Billing Information (PIF)
                  </h4>
                  <small className="text-muted">
                    Review and verify publisher bank details
                  </small>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <Button
                    className="btn-gradient-primary btn-sm"
                    onClick={() => setIsBankModalOpen(true)}
                  >
                    <i className="fa fa-plus mr-1" />
                    Add New Bank Account
                  </Button>
                </div>
              </div>

              {showLoader && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{ fontSize: "25px" }}
                  />
                </div>
              )}

              {hasBillingInfo && !showLoader ? (
                <>
                  <Row>
                    {/* Left Column */}
                    <Col md={6}>
                      <Field
                        label="Legal Entity Name"
                        value={billingInfoForm.legal_entity_name?.value}
                      />
                      <Field
                        label="Billing Address"
                        value={billingInfoForm.billing_address?.value}
                      />
                      <Field
                        label="Country"
                        value={billingInfoForm.country_name?.value || billingInfoForm.country_id?.value}
                      />
                      <Field
                        label="TRN/VAT ID"
                        value={billingInfoForm.trn_vat_id?.value}
                      />
                      <Field
                        label="Payment Terms"
                        value={billingInfoForm.payment_terms?.value}
                      />
                      <Field
                        label="Minimum Payout"
                        value={billingInfoForm.minimum_payout?.value ? `$${billingInfoForm.minimum_payout.value}` : "-"}
                      />
                      <Field
                        label="Bank Name"
                        value={billingInfoForm.bank_name?.value}
                      />
                      <Field
                        label="Status"
                        value={getStatusBadge(billingInfoForm.approval_status?.value || "PENDING")}
                      />


                    </Col>

                    {/* Right Column */}
                    <Col md={6}>
                      <Field
                        label="Bank Account"
                        value={billingInfoForm.bank_account?.value}
                      />
                      <Field
                        label="IBAN"
                        value={billingInfoForm.iban?.value}
                      />
                      <Field
                        label="SWIFT/BIC"
                        value={billingInfoForm.swift_code?.value || billingInfoForm.swift_bic?.value}
                      />
                      <Field
                        label="IFSC Code"
                        value={billingInfoForm.ifsc_code?.value}
                      />
                      <Field
                        label="Invoice Email"
                        value={billingInfoForm.invoice_email?.value}
                      />
                      <Field
                        label="Tax Residency"
                        value={billingInfoForm.tax_residency?.value}
                      />
                      <Field
                        label="Currency"
                        value={billingInfoForm.payment_currency?.value}
                      />
                    </Col>
                  </Row>


                </>
              ) : (
                <div className="text-center my-4">
                  <span className="text-muted">
                    No Billing Information Available
                  </span>
                </div>
              )}
            </CardBody>
          </Card>

          {/* Bank Details History Table */}
          <Card className="mt-4">
            <ReactBsTable
              title="Bank Details History"
              description="View all previous bank details"
              data={bankHistory}
              columns={bankHistoryColumns}
              keyField="id"
              page={1}
              sizePerPage={10}
              totalRecords={bankHistory.length}
              showLoader={historyLoader}
              bordered
              hover
              enablePageSizeManagement={false}
              showAddbtn={false}
              showColumnsBtn={false}
              exportCSVBtnShow={false}
            />
          </Card>
        </Container>
      </div>

      {/* Bank Details Modal */}
      <BankDetailModal
        isOpen={isBankModalOpen}
        toggleModal={() => setIsBankModalOpen(false)}
        onSubmit={handleBankSubmit}
        onBillingComplete={() => {
          notify("success", "Bank details added successfully!");
          setIsBankModalOpen(false);
          Promise.all([getBillingInfo(), getBankHistory()]);
        }}
      />
    </>
  );
};

export default Publisher_Billing;